import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import { IFormProfileExt } from 'legacy/lut/classes/models/IFormProfileExt'
import { SaveAsDraftContact } from 'legacy/lut/components/widgets/public/contactEditDialog/saveAsDraftContact/SaveAsDraftContact'
import { useEffect, useMemo, useState } from 'react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { WidgetContactEditDialog } from '../ContactEditDialog'

import styles from './DraftContactDialog.module.scss'

interface IModalStatuses {
  saveAsDraft: boolean
  warning: boolean
  editModal: boolean
}

interface IProps {
  draft: IFormProfile
  appSource?: string
  onApply?: () => void
  setContactSaved?: (contact: IFormProfile | IFormProfileExt | null) => void
}

export const DraftContactDialog = ({ draft, appSource, onApply, setContactSaved }: IProps) => {
  const [changeContactRequest, setChangeContactRequest] = useState<IFormProfile>({} as IFormProfile)
  const [showDialog, setShowDialog] = useState<IModalStatuses>({
    saveAsDraft: true,
    warning: false,
    editModal: false,
  })

  useEffect(() => {
    setShowDialog((showDialog) => ({ ...showDialog, saveAsDraft: true }))
  }, [draft])

  const saveAsDraftContactProps = useMemo(() => {
    return {
      onClose: (showWarning: boolean) => {
        setShowDialog((showDialog) => ({
          ...showDialog,
          saveAsDraft: false,
          warning: showWarning,
        }))
      },
      draftContact: draft,
      createChangeContactRequest: (item: IFormProfile) => setChangeContactRequest(item),
      appSource,
      onApply,
      setContactSaved,
    }
  }, [draft, appSource, onApply, setContactSaved])

  return (
    <>
      <ModalDialog
        size={'xs'}
        show={showDialog.saveAsDraft}
        onClose={() => setShowDialog({ ...showDialog, saveAsDraft: false })}
        content={SaveAsDraftContact}
        contentProps={saveAsDraftContactProps}
      />
      <ModalDialog
        show={showDialog.warning}
        size={'xs'}
        onClose={() => {
          setShowDialog({ ...showDialog, warning: false })
        }}
        content={() => {
          return (
            <div className={styles.modal}>
              <p className={styles.modal__title}>
                Contact is saved as draft and{' '}
                <u>will be created after the partner submits their company details.</u>
                <br />
                <br />
                <b>Important!</b> If you are adding a new contact as <b>L&R Champion</b>, then click
                on ‘Create contact’, fill in all mandatory details, assign L&R Champion role and
                click on ‘Apply’ button to create the contact.
                <br />
              </p>

              <footer className={styles.modal__footer}>
                <Button
                  className={styles.modal__button}
                  onClick={async () => {
                    setShowDialog({
                      ...showDialog,
                      warning: false,
                      editModal: true,
                    })
                  }}
                >
                  Create contact
                </Button>
                <Button
                  className={styles.modal__button}
                  variant={'outlined'}
                  color={'danger'}
                  onClick={() => setShowDialog({ ...showDialog, warning: false })}
                >
                  Leave contact as draft
                </Button>
              </footer>
            </div>
          )
        }}
      />

      {showDialog.editModal && (
        <WidgetContactEditDialog
          dialogEntryId={1}
          entryIdItem={changeContactRequest}
          onClose={() => {
            setShowDialog({ ...showDialog, editModal: false })
            setContactSaved && setContactSaved(null)
          }}
          appSource={appSource}
        />
      )}
    </>
  )
}
